const hideField = (field: string) => {
  return field.split(' ').reduce((acc, curr) => {
    if (curr.length <= 2) {
      return acc + curr.slice(0, 1) + '* ';
    } else {
      return acc + curr.slice(0, 1) + '*'.repeat(curr.length - 2) + curr.slice(-1) + ' ';
    }
  }, '');
};

export { hideField };
